import { fetchApi } from '@/config/axiosSetting';
import { PostPoliceReportQueryParamsType } from '@/modules/adjusterReportModules/adjusterReport/queries/policeReport/postPoliceReport/policeReportQuery.type';

export const postPoliceReportFunction = (
  params: PostPoliceReportQueryParamsType,
) => {
  return fetchApi.patch(`${params.id}/report/police_report/`, params.data);
};
